export const HOME = "/";
const AUTH = "/auth";
export const DASHBOARD = `${AUTH}/dashboard`;
export const AI_TOOL_MANAGEMENT = `${AUTH}/ai-tool-management`;
export const AI_TOOL_MANAGEMENT_CREATE_TOOL = `${AI_TOOL_MANAGEMENT}/create-tool`;
export const ACCOUNT_MANAGEMENT = `${AUTH}/account-management`;
export const ACCOUNT_MANAGEMENT_TRANSACTIONS = `${ACCOUNT_MANAGEMENT}/transactions`;
export const ACCOUNT_MANAGEMENT_BILLING_DETAILS = `${ACCOUNT_MANAGEMENT}/billing-details`;
export const ACCOUNT_MANAGEMENT_USER_MANAGEMENT = `${ACCOUNT_MANAGEMENT}/user-management`;

const PARTNER_MANAGEMENT = `${AUTH}/partner-management`;
export const PARTNER_MANAGEMENT_PARTNERS = `${PARTNER_MANAGEMENT}/partners`;
export const PARTNER_MANAGEMENT_CREATE_CREDENTIAL = `${PARTNER_MANAGEMENT}/create-credential`;
export const PARTNER_MANAGEMENT_CREATE_PARTNER = `${PARTNER_MANAGEMENT}/create-partner`;

export const PRIVACY_POLICY = `/privacy-policy`;

export const LOGIN = `${AUTH}/dashboard`;
